import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { DeleteModal } from 'Components';
import { useUpdatePersonalDetailsDictionary } from 'Hooks/useUpdatePersonalDetailsDictionary';
import { MaleIcon, Delete, Edit, FemaleIcon } from 'Images';
import { format } from 'date-fns';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

interface IChildCard {
  index: number;
  onDelete: () => void;
  onEdit: () => void;
}

export const ChildCard = ({ index, onDelete, onEdit }: IChildCard) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { watch } = useFormContext();
  const dictionary = useUpdatePersonalDetailsDictionary().addChild;

  const isBoy = () => watch('familyMembers.' + index + '.gender') === 1;

  return (
    <Stack
      boxShadow={'none'}
      borderRadius={'12px'}
      bgcolor={'purple2.shade_50'}
      border={'1px solid'}
      borderColor={'purple2.shade_100'}
      padding={'16px'}
      tabIndex={0}
      gap={'20px'}
    >
      <Stack direction={'row'} gap={'12px'}>
        <Avatar
          src={isBoy() ? MaleIcon : FemaleIcon}
          alt=''
          sx={{
            width: '32px',
            height: '32px',
            position: 'relative',
            top: '-5px',
          }}
        />
        <Stack gap={'8px'}>
          <Typography
            role='heading'
            variant={'body4'}
            textOverflow={'elipsis'}
            overflow={'hidden'}
            whiteSpace={'nowrap'}
          >
            {`${watch('familyMembers.' + index + '.firstName') || ''} ${
              watch('familyMembers.' + index + '.lastName') || ''
            }`}{' '}
            ({isBoy() ? dictionary.child.boy : dictionary.child.girl})
          </Typography>
          <Stack direction={'row'} gap={'24px'}>
            <Stack width={'auto'}>
              <Typography variant={'body6'} tabIndex={0}>
                {dictionary.idNumber}
              </Typography>
              <Typography
                variant={'body2'}
                textOverflow={'elipsis'}
                overflow={'hidden'}
                whiteSpace={'nowrap'}
              >
                {watch('familyMembers.' + index + '.identityNumber') || ''}
              </Typography>
            </Stack>
            <Stack width={'auto'}>
              <Typography variant={'body6'} tabIndex={0}>
                {dictionary.dob}
              </Typography>
              <Typography variant={'body2'}>
                {(watch('familyMembers.' + index + '.birthDate') &&
                  format(
                    watch('familyMembers.' + index + '.birthDate'),
                    'dd.MM.yyyy'
                  )) ||
                  ''}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        justifyContent={'flex-end'}
        gap={'16px'}
        component='fieldset'
      >
        <legend>{`${watch('familyMembers.' + index + '.firstName') || ''} ${
          watch('familyMembers.' + index + '.lastName') || ''
        }`}</legend>
        <ButtonBase
          onClick={onEdit}
          aria-label={`${dictionary.edit} ${
            watch('familyMembers.' + index + '.firstName') || ''
          } ${watch('familyMembers.' + index + '.lastName') || ''}`}
        >
          <Stack direction={'row'} gap={'4px'}>
            <Avatar
              src={Edit}
              alt={dictionary.edit}
              sx={{
                height: '20px',
                width: '20px',
                cursor: 'pointer',
                border: 'none',
                bgcolor: 'transparent',
                p: 0,
              }}
            />
            <Typography variant={'body6'}>{dictionary.edit}</Typography>
          </Stack>
        </ButtonBase>
        <ButtonBase
          onClick={() => setShowDeleteModal(true)}
          aria-label={`${dictionary.delete} ${
            watch('familyMembers.' + index + '.firstName') || ''
          } ${watch('familyMembers.' + index + '.lastName') || ''}`}
        >
          <Stack direction={'row'} gap={'4px'}>
            <Avatar
              src={Delete}
              alt={dictionary.delete}
              sx={{
                height: '20px',
                width: '20px',
                cursor: 'pointer',
                border: 'none',
                bgcolor: 'transparent',
                p: 0,
              }}
            />
            <Typography variant={'body6'}>{dictionary.delete}</Typography>
          </Stack>
        </ButtonBase>
      </Stack>
      <DeleteModal
        closeModal={() => setShowDeleteModal(false)}
        isVisible={showDeleteModal}
        deleteFile={onDelete}
      />
    </Stack>
  );
};
